/* Raised cents in prices the theme does not render itself. The bundle app's
   rows and the cart app's drawer write plain "99,99 €" text, and the theme's
   own scripts rewrite the product page's figures after a bundle is picked.
   Whatever lands in one of these elements is split into euros, comma, cents
   and sign — the same spans snippets/money.liquid writes — the moment it
   appears. The split keeps textContent exactly as it was, which is all the
   apps and the theme's price scripts ever read back; an element already
   split, or one holding other elements, is left alone. */
(function () {
  'use strict';

  var SEL = [
    '[data-kaching-price]',
    '[data-kaching-price-compare]',
    '[data-buybar-price]',
    '.kaching-bundles__bar-price',
    '.kaching-bundles__bar-full-price',
    '.kaching-cart-item__total-final',
    '.kaching-cart-item__total-old',
    '.kaching-product-upsell-item__price-final',
    '.kaching-product-upsell-item__price-old'
  ].join(',');

  /* "99,99 €", "1 234,99 €", and the cart app's "⁨99,99 €⁩" with its
     bidi isolates around the figure, which are kept as they were. */
  var RE = /^([⁨⁩\s]*)([\d\s .]+)([,.])(\d{2})(\s*€)([⁨⁩\s]*)$/;

  function span(cls, text) {
    var s = document.createElement('span');
    s.className = cls;
    s.textContent = text;
    return s;
  }

  function split(el) {
    if (!el || el.children.length) return;
    var m = (el.textContent || '').match(RE);
    if (!m) return;
    var amt = span('nagi-money__amt', '');
    amt.appendChild(span('nagi-money__whole', m[2]));
    amt.appendChild(span('nagi-money__comma', m[3]));
    amt.appendChild(span('nagi-money__cents', m[4]));
    el.textContent = '';
    if (m[1]) el.appendChild(document.createTextNode(m[1]));
    el.appendChild(amt);
    el.appendChild(span('nagi-money__cur', m[5]));
    if (m[6]) el.appendChild(document.createTextNode(m[6]));
  }

  function run() {
    queued = 0;
    var list = document.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) split(list[i]);
    /* The cart drawer's totals and notes carry no stable hooks: every leaf
       in it whose whole text is a figure gets the split. */
    var cart = document.querySelectorAll('.kaching-cart *');
    for (var k = 0; k < cart.length; k++) {
      if (!cart[k].children.length) split(cart[k]);
    }
    /* The bundle app's corner badges are set in its admin; one that speaks
       of the price (KAINA, NUOLAIDA, PASIŪLYMAS, VERTĖ; on kurashi.ee HIND,
       SOODUS, PAKKUMINE, VÄÄRT) gets the offer green through a class
       money-cents.css reads; the rest keep the cream. */
    var badges = document.querySelectorAll('.kaching-bundles__bar-most-popular__content');
    for (var b = 0; b < badges.length; b++) {
      var offer = /KAIN|NUOLAID|PASIŪLYM|VERT|HIND|SOODUS|PAKKUMI|VÄÄRT/i.test(badges[b].textContent || '');
      if (offer !== badges[b].classList.contains('nagi-badge--offer')) badges[b].classList.toggle('nagi-badge--offer', offer);
    }
  }

  var queued = 0;
  function schedule() {
    if (!queued) queued = window.requestAnimationFrame(run);
  }

  run();
  if ('MutationObserver' in window) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  }
  window.addEventListener('load', schedule);
})();
